import { c as _c } from "react/compiler-runtime";
import { TOUR_REMINDER_URL } from "@website/accommodation-ui/constant";
import { UpdateReminderBody } from "@website/accommodation-ui/tour-reminder/types";
import { fetcher } from "@website/fetcher/fetcher";
import { useFetcherV2 } from "@website/fetcher/use-fetcherV2";
export const useSearchReminder = enabled => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [TOUR_REMINDER_URL, "search"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== enabled) {
    t1 = {
      enabled,
      queryKey: t0,
      queryFn: _temp2
    };
    $[1] = enabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useFetcherV2(t1);
};
export const updateReminders = (body: UpdateReminderBody) => fetcher({
  url: TOUR_REMINDER_URL,
  method: "POST",
  data: body,
  headers: {
    product: "TOUR"
  }
});
function _temp(t0) {
  const {
    data
  } = t0;
  return data;
}
function _temp2() {
  return fetcher({
    url: TOUR_REMINDER_URL,
    method: "GET",
    params: {
      property_id: 0
    },
    headers: {
      product: "TOUR"
    }
  }).then(_temp);
}